import { BeerFormState } from "./types";
import { User } from "./types";

export const defaultBeerFormState: BeerFormState = {
  beerName: "",
  quantity: "",
  abv: "",
  description: "",
  price: "",
  ibu: "",
  fileUpload: [],
};

export const defaultUserData: User = {
  firstName: "",
  lastName: "",
  email: "",
};
